<script setup>
import { ref, computed } from "vue";
import axios from "axios"; /*cmdでのインストール未完了*/
import { format } from "date-fns";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { useStore } from "@/store/authStore";
import useRole from "@/components/role";
import { useRoleStore } from "@/store/roleStore";
import { useApiStore } from "@/store/apiStore";
const apiStore = useApiStore();
const roleStore = useRoleStore();
const { hasPermission } = useRole();

const store = useStore(); // Pinia storeを使用します
const accessToken = computed(() => {
  if (store.getAuthToken) {
    return store.getAuthToken; // 「payload」オブジェクトの中の「name」フィールドを取得します
  } else {
    return null;
  }
});

const tokenHeaders = {
  headers: {
    Authorization: `Bearer ${accessToken.value}`,
  },
};

/*初期値*/
const uploadfile = ref({
  target: "",
  fromDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS"),
  toDate: format(
    new Date(9999, 11, 31, 23, 59, 59, 0),
    "yyyy-MM-dd'T'HH:mm:ss.SSS"
  ),
  csvfile: "",
});

// POST先URL
const apiUrl = apiStore.getCsvPath;

// アップロード対象リスト
const targets = ref([]);
targets.value = [
  { value: "prize", text: "賞金ランキング" },
  { value: "original", text: "オリジナル指数" },
];

let errMessage = ref();
let resultMessage = ref("");
let isFromToDateInvalid = ref(false);
let isCsvInvalid = ref(false);
let isTargetInvalid = ref(false);
let isRegistrationNow = ref(false);
// CSV選択ボタン処理
const uploadcsv = (event) => {
  const file = event.target.files[0];

  // キャンセルされた場合fileの中身がundefinedになる(Edgeとchrome？)
  if (file === undefined) {
    uploadfile.value.csvfile = "";
    event.currentTarget.value = "";
    return;
  }

  // 拡張子チェック
  if (file.name.split(".").pop() !== "csv") {
    event.currentTarget.value = "";
    uploadfile.value.csvfile = "";
    alert("選択したファイルはCSVファイルである必要があります。");
    return;
  }

  // CSVファイル読み込み
  const reader = new FileReader();
  reader.onload = (e) => {
    uploadfile.value.csvfile = e.target.result;
  };
  reader.readAsDataURL(file);

  console.log(file);
  console.log(uploadfile.value);
};

// 送信ボタン処理
const send = async () => {
  // 結果メッセージクリア
  resultMessage.value = "";

  // 掲載開始と終了の日時のバリデーション
  if (
    new Date(uploadfile.value.toDate) <= new Date(uploadfile.value.fromDate)
  ) {
    isFromToDateInvalid.value = true;
  } else {
    isFromToDateInvalid.value = false;
  }

  // csvファイル有無チェック
  if (uploadfile.value.csvfile == "") {
    isCsvInvalid.value = true;
  } else {
    isCsvInvalid.value = false;
  }

  // アップロード対象チェック
  if (uploadfile.value.target == "") {
    isTargetInvalid.value = true;
  } else {
    isTargetInvalid.value = false;
  }

  // エラーメッセージ作成
  let messages = [];
  if (isFromToDateInvalid.value) {
    messages.push("掲載開始時刻と掲載終了時刻が不正です");
  }
  if (isCsvInvalid.value) {
    messages.push("CSVファイルが選択されていません");
  }
  if (isTargetInvalid.value) {
    messages.push("アップロード対象が選択されていません");
  }
  errMessage.value = messages.join("\n");

  // 入力エラーがある場合は処理を止める
  if (
    isCsvInvalid.value ||
    isFromToDateInvalid.value ||
    isTargetInvalid.value
  ) {
    alert(errMessage.value);
    return;
  }

  // JSON型式文字列作成
  let upjson = ref({});
  upjson.value.fromDate = uploadfile.value.fromDate;
  upjson.value.toDate = uploadfile.value.toDate;
  upjson.value.data = uploadfile.value.csvfile;

  // 登録中フラグON
  isRegistrationNow.value = true;

  // サーバーにPOST
  let response = null;
  response = await axios
    .post(apiUrl + "/" + uploadfile.value.target, upjson.value, tokenHeaders)
    .catch(function (error) {
      console.log(error.toJSON());
      alert("アップロードエラー\n" + error);
    });

  // レスポンスがエラーだった場合はアラートを出す
  if (!response) {
    // 登録中フラグOFF
    isRegistrationNow.value = false;
    return;
  }

  // レスポンスが成功だった場合、成功メッセージ表示
  if (response.status / 100 === 2) {
    console.log(response);
    console.log("アップロード成功");
  } else {
    console.error(response);
    console.error("CSVのアップロードに失敗しました");
  }

  // 結果メッセージ設定
  if (response.data.message.length > 0) {
    resultMessage.value = response.data.message.join("\r\n");
    alert("CSVをアップロードできませんでした。");
  } else {
    resultMessage.value =
      "登録完了しました（登録数:" + response.data.count + "件）";
    alert("CSVをアップロードしました。");
  }
  // 登録中フラグOFF
  isRegistrationNow.value = false;
};
</script>

<template>
  <div class="content_parent registration d-flex flex-column">
    <div class="title content_line">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle">アップロード対象選択</div>
        </div>
        <div class="content_item">
          <select class="input_content form-select" v-model="uploadfile.target">
            <option
              v-for="target in targets"
              :value="target.value"
              :key="target.value"
            >
              {{ target.text }}
            </option>
          </select>
          <p v-if="isTargetInvalid" class="error-message">
            アップロード対象は必須項目です。
          </p>
        </div>
      </div>
    </div>
    <div class="content_line d-flex frex-row">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle">公開日時</div>
        </div>
        <div class="content_item flex-column mt-2">
          <div class="d-flex flex-row">
            <VueCtkDateTimePicker
              class="csvupload_input_date input_content_date"
              :button-clear="false"
              v-model="uploadfile.fromDate"
              format="YYYY-MM-DDTHH:mm"
              formatted="YYYY年MM月DD日 HH:mm"
              :no-header="true"
              :no-button-now="true"
              label="日付を選択"
              no-label
              no-clear-button
              auto-close
            />
            <span class="span-nami">～</span>
            <VueCtkDateTimePicker
              class="csvupload_input_date input_content_date"
              :button-clear="false"
              v-model="uploadfile.toDate"
              format="YYYY-MM-DDTHH:mm"
              formatted="YYYY年MM月DD日 HH:mm"
              :no-header="true"
              :no-button-now="true"
              label="日付を選択"
              no-label
              no-clear-button
              auto-close
            />
          </div>
          <p
            v-if="isFromToDateInvalid"
            class="error-message error-message-date"
          >
            掲載開始時刻と掲載終了時刻が不正です
          </p>
        </div>
      </div>
    </div>
    <div class="title content_line">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle">アップロードデータ指定</div>
        </div>
        <div class="content_item d-flex flex-column">
          <input
            type="file"
            accept=".csv"
            class="p-2 input_content"
            @change="uploadcsv($event)"
          />
        </div>
        <p v-if="isCsvInvalid" class="error-message">
          アップロードデータは必須項目です。
        </p>
      </div>
    </div>
    <div class="send_button">
      <button
        :disabled="
          !hasPermission(roleStore.role, 'RANKING') || isRegistrationNow
        "
        class="submit_button"
        v-on:click="send"
      >
        <div v-if="isRegistrationNow">登録中</div>
        <div v-else>登録</div>
      </button>
    </div>

    <div
      class="error-message"
      style="word-wrap: break-word; white-space: pre-wrap"
    >
      {{ resultMessage }}
    </div>
  </div>
</template>

<style scoped>
.texttitle {
  min-width: 12em;
  max-width: 12em;
}
.input_content_date {
  min-width: 3em !important;
  width: 12em !important;
}
.input_content {
  box-sizing: content-box;
  padding: 5 0px;
  margin: 0px;
  min-height: 1.8em;
  min-width: 9em;
  font-size: 1em;
}

.error-message {
  text-align: left;
}
</style>
